import { render, staticRenderFns } from "./cusTable.vue?vue&type=template&id=e2991a6c&scoped=true&"
import script from "./cusTable.vue?vue&type=script&lang=js&"
export * from "./cusTable.vue?vue&type=script&lang=js&"
import style0 from "./cusTable.vue?vue&type=style&index=0&id=e2991a6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2991a6c",
  null
  
)

export default component.exports